export default "data:image/gif;base64,R0lGODlhFQAEAPABAKGhoQAAACH5BAUKAAEALAAAAAAVAAQAAAINjI8Bya2wnINUMopZAQA7"